var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.264,
    height: 38.376,
    viewBox: "0 0 38.264 38.376",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "target_9_",
    "data-name": "target (9)",
    transform: "translate(-2.036 -2.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52737",
    "data-name": "Path 52737",
    d: "M36.16,17.009a4.792,4.792,0,0,1-3.39,1.407H30.052L30,18.465a10.468,10.468,0,0,1,.432,2.942A10.05,10.05,0,1,1,20.377,11.349a9.447,9.447,0,0,1,2.782.4l.08-.08V8.9a4.7,4.7,0,0,1,1.407-3.39l1.519-1.519a17.975,17.975,0,0,0-5.773-.943A18.349,18.349,0,1,0,38.735,21.391a17.81,17.81,0,0,0-1.007-5.949Z",
    transform: "translate(0 0.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52738",
    "data-name": "Path 52738",
    d: "M35.186,7.787a1.616,1.616,0,0,0-1.391-1.04l-3.038-.224-.224-3.038a1.595,1.595,0,0,0-2.718-1.023L21.881,8.395a1.583,1.583,0,0,0-.464,1.135v4.078L17.5,17.582a4.912,4.912,0,0,0-7.08,4.437,4.949,4.949,0,1,0,9.9,0,4.861,4.861,0,0,0-.54-2.194l3.914-3.979H27.75a1.61,1.61,0,0,0,1.135-.464L34.8,9.466A1.6,1.6,0,0,0,35.186,7.787Z",
    transform: "translate(5.02 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIcon);
export default __webpack_public_path__ + "static/media/target-icon.a40cd1d91334fad28db9086248b3bf32.svg";
export { ForwardRef as ReactComponent };